import { OdnoklassnikiIcon } from './OdnoklassnikiIcon';

/**
 * author: Contributors
 * id 8BB24B94-491F-4465-8E87-45FF8FED7C4A
 * name odnoklassniki
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/odnoklassniki.svg
 * tags
 * - Brand / Logo 
 */
export const OkRuIcon = OdnoklassnikiIcon;
export default OkRuIcon